//? Parse helper wrapper
export function tryParseJson(input: string) {
    try {
        return JSON.parse(input);
    } catch (e) {
        //console.log("Try parse json failed");
        return input;
    }
}

//? Use: await sleep(3000);
export function sleep(ms: number) {
    return new Promise(resolveFunc => setTimeout(resolveFunc, ms));
}